/* Lukante theme JS */
jQuery(document).ready(function ($) {

    const logo = $(".navbar img");
    const navbar = $("#main-nav");

    const logoLight = "/wp-content/uploads/2026/07/logo-white.png";
    const logoDark = "/wp-content/uploads/2026/07/logo-przewiezsobie.png";

    let scrolled = false;

    $(window).on("scroll", function () {

        if ($(window).scrollTop() > 1 && !scrolled) {

            scrolled = true;

            navbar
                .addClass("active-header navbar-dark")
                .removeClass("navbar-light");

            logo.attr({
                src: logoLight,
                srcset: logoLight
            });

        } else if ($(window).scrollTop() <= 1 && scrolled) {

            scrolled = false;

            navbar
                .removeClass("active-header navbar-dark")
                .addClass("navbar-light");

            logo.attr({
                src: logoDark,
                srcset: logoDark
            });
        }

    });

});

document.addEventListener('DOMContentLoaded', () => {

    const navbar = document.getElementById('navbarNavDropdown');
    const toggler = document.querySelector('.navbar-toggler');

    if (!navbar || !toggler) return;

    navbar.addEventListener('click', (e) => {

        const link = e.target.closest('.nav-link');

        if (!link) return;

        if (window.innerWidth < 768 && navbar.classList.contains('show')) {
            toggler.click();
        }

    });

});
